import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { FaDiscord } from 'react-icons/fa';
import './DiscordGuide.css';

// Мини-инструкция перед переходом в Discord: вход → кнопка Open Chat → именной тикет
const DiscordGuide = ({ isOpen, onClose, inviteUrl }) => {
  const ctaRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    const prevOverflow = document.body.style.overflow;
    const prevFocus = document.activeElement;
    document.body.style.overflow = 'hidden';
    if (ctaRef.current) ctaRef.current.focus({ preventScroll: true });

    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = prevOverflow;
      if (prevFocus && prevFocus.focus) prevFocus.focus({ preventScroll: true });
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Закрываем с задержкой: если убрать ссылку из DOM прямо в клике, браузер не откроет вкладку
  const handleContinue = () => setTimeout(onClose, 150);

  // Портал в body: у .cta-card есть backdrop-filter, он ломает position: fixed внутри
  return createPortal(
    <div className="dg-overlay" onClick={onClose}>
      <div
        className="dg-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="dg-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="dg-close" onClick={onClose} aria-label="Close">
          <svg viewBox="0 0 14 14" width="12" height="12" aria-hidden="true">
            <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>

        <div className="dg-head">
          <div className="dg-icon"><FaDiscord /></div>
          <h3 id="dg-title" className="dg-title">Chat with us on Discord</h3>
          <p className="dg-sub">Your own support ticket in 3 clicks</p>
        </div>

        <ol className="dg-steps">
          <li className="dg-step">
            <span className="dg-num">1</span>
            <div className="dg-step-body">
              <strong>Join our server</strong>
              <span className="dg-step-text">The invite opens in a new tab.</span>
            </div>
          </li>
          <li className="dg-step">
            <span className="dg-num">2</span>
            <div className="dg-step-body">
              <strong>Press <span className="dg-kbd">Open Chat</span></strong>
              <span className="dg-step-text">You'll see it right at the entrance.</span>
            </div>
          </li>
          <li className="dg-step">
            <span className="dg-num">3</span>
            <div className="dg-step-body">
              <strong>Open your ticket &amp; say hi</strong>
              <span className="dg-step-text">
                A ticket with your name is created — go in and send any message. We'll reply right there.
              </span>
            </div>
          </li>
        </ol>

        <a
          ref={ctaRef}
          href={inviteUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="dg-cta"
          onClick={handleContinue}
        >
          <FaDiscord />
          <span>Continue to Discord</span>
          <span aria-hidden="true">→</span>
        </a>
      </div>
    </div>,
    document.body
  );
};

export default DiscordGuide;
